export default function (state, setting) {
    console.info("change settings: changedSetting: ", setting);
    state.settings[state.settings.findIndex(x => x.Id == setting.Id)] = setting;
    console.info('settings: ', state.settings);
}